import * as React from 'react';
import styled from 'styled-components';
import {
  centimetersToInches,
  inchesToCentimeters,
} from '../../../utils/conversions';
import { roundValue } from '../../../utils/math';
import { Row } from '../../layout/Row';
import { ControlLabel } from './ControlLabel';
import { Input } from './Input';
interface IProps {
  value: number;
  onChange: (val: number) => void;
}

export const HeightInput = (props: IProps): React.ReactElement => {
  const [selectedUnits, setSelectedUnits] = React.useState<string>('cm');
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    if (selectedUnits === 'cm') {
      props.onChange(+value);
    }
    if (selectedUnits === 'in') {
      props.onChange(roundValue(inchesToCentimeters(+value), 2));
    }
  };

  const getDisplayHeight = (): number => {
    if (selectedUnits === 'cm') {
      return props.value;
    }
    if (selectedUnits === 'in') {
      return roundValue(centimetersToInches(props.value), 2);
    }
  };

  const height = getDisplayHeight();

  return (
    <Container>
      <Row style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
        <Label htmlFor='height'>Height</Label>
        <UnitToggle role='group' aria-label='Height units'>
          <UnitOption
            type='button'
            selected={selectedUnits === 'cm'}
            aria-pressed={selectedUnits === 'cm'}
            onClick={(): void => setSelectedUnits('cm')}
          >
            cm
          </UnitOption>
          <UnitOption
            type='button'
            selected={selectedUnits === 'in'}
            aria-pressed={selectedUnits === 'in'}
            onClick={(): void => setSelectedUnits('in')}
          >
            in
          </UnitOption>
        </UnitToggle>
      </Row>
      <Input
        id='height'
        name='height'
        value={height || ''}
        onChange={changeHandler}
        placeholder='Height...'
        type='number'
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Label = styled(ControlLabel as any)`
  margin-left: 4px;
  margin-bottom: 3px;
`;

const UnitToggle = styled.div`
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid var(--color-surface-6);
`;

const UnitOption = styled.button.withConfig({
  shouldForwardProp: (prop: string) => prop !== 'selected',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any)<{ selected: boolean }>`
  padding: 1px 8px;
  font-size: 12px;
  line-height: 1.4;
  border: none;
  cursor: pointer;
  background: ${(props): string =>
    props.selected ? 'var(--color-primary)' : 'var(--color-surface-3)'};
  color: ${(props): string =>
    props.selected ? 'var(--color-button-text)' : 'var(--color-text)'};
  transition: background 0.15s ease;

  &:hover {
    background: ${(props): string =>
      props.selected ? 'var(--color-primary)' : 'var(--color-surface-6)'};
  }
`;
